import { render, staticRenderFns } from "./ReleaseNotesIssuesList.vue?vue&type=template&id=0105af0a&"
import script from "./ReleaseNotesIssuesList.vue?vue&type=script&lang=js&"
export * from "./ReleaseNotesIssuesList.vue?vue&type=script&lang=js&"
import style0 from "./ReleaseNotesIssuesList.vue?vue&type=style&index=0&id=0105af0a&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports